import React from "react";
import { Box, Typography } from "@mui/material";
import { purple } from "@mui/material/colors";
import PageLayout from "examples/LayoutContainers/PageLayout";

const primary = purple[500]; // #f44336

export default function PageNotFound() {
  return (
    <PageLayout>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          backgroundColor: primary,
          flexDirection: "column",
        }}
      >
        <Typography variant="h1" style={{ color: "white" }}>
          404
        </Typography>
        <Typography variant="h5" style={{ color: "white" }}>
          Page Not Found
        </Typography>
      </Box>
    </PageLayout>
  );
}
